// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3bMi2","list":"styles_list__aY6iM"};